import React from "react";
import { useTranslation } from "react-i18next";
import { useAbsenceTypeLabel } from "./AbsenceBar";
import { getAbsenceTypeColor } from "./teamOverviewUtils";

const DAY_ITEMS = [
  { className: "team-overview__day--weekend", label: "components.Calendar.teamOverview.weekend" },
  { className: "team-overview__day--holiday", label: "components.Calendar.teamOverview.holiday" },
  { className: "team-overview__day--today", label: "components.Calendar.today" },
];

const TeamOverviewLegend = ({ absenceTypes = [] }) => {
  const { t } = useTranslation();
  const getTypeLabel = useAbsenceTypeLabel();

  return (
    <ul className="team-overview__legend">
      {absenceTypes.map((type) => (
        <li key={type}>
          <span className="team-overview__swatch" style={{ backgroundColor: getAbsenceTypeColor(type) }} />
          {getTypeLabel(type)}
        </li>
      ))}
      {DAY_ITEMS.map(({ className, label }) => (
        <li key={label}>
          <span className={`team-overview__swatch ${className}`} />
          {t(label)}
        </li>
      ))}
    </ul>
  );
};

export default TeamOverviewLegend;
